import * as ACTIONS from "@iso/redux/feedbacks/actionTypes";

const initialState = {
  feedbacks: {
    list: [],
    total: 0,
  },
};

function feedbacksReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_FEEDBACKS_SUCCESS: {
      return {
        ...state,
        ...{ feedbacks: payload },
      };
    }
    default:
      return state;
  }
}

export default feedbacksReducer;
